module.exports = __webpack_public_path__ + "assets/img/7638f7395055ea054159e190b6a5562d.svg";